import { ITextItemLinkModel, ITextItemLinkValue } from '@fi-shared/fi-text-item-helper/fi-text-item-link';
import { FiLinkToType } from '@fi-shared/fi-text-item-helper/fi-link-to-type';

export class LinkToModel implements ITextItemLinkModel {
    Type: FiLinkToType;
    Value: ITextItemLinkValue;
    EditTitle?: string;
    constructor(params?) {
        Object.assign(this, params);
    }
}
